import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,

} from '@mui/material';
import overallservices from '../services/overallservices';
import RecommendationComponent from '../components/Recomendation'; 

const AssessmentComponent = ({ assessments, contentId, onAssessmentSubmit }) => {
  const questionsPerPage = 2;
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState(Array(assessments.length).fill(''));
  const [score, setScore] = useState(0);
  const [showResult,setShowResult]=useState(false)
  const isPageAnswered = selectedOptions.slice(currentPage * questionsPerPage, (currentPage + 1) * questionsPerPage).every(option => option !== '');

  const handleOptionChange = (event, questionIndex) => {
    const newSelectedOptions = [...selectedOptions];
    newSelectedOptions[questionIndex] = event.target.value;
    setSelectedOptions(newSelectedOptions);
  };

  const handleNextClick = () => {
    const totalPages = Math.ceil(assessments.length / questionsPerPage);
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    } else {
      setShowResult(true);
    }
  };

  const calculateScore = () => {
    let correctAnswers = 0;
    selectedOptions.forEach((option, index) => {
      if (option === assessments[index].correct) {
        correctAnswers++;
      }
    });
    return correctAnswers;
  };

  const handleFinishClick = () => {
   
    setShowRecommendation(true); 
  };



  const renderQuestions = () => {
    const startIndex = currentPage * questionsPerPage;
    const endIndex = Math.min(startIndex + questionsPerPage, assessments.length);

    return assessments.slice(startIndex, endIndex).map((assessment, index) => (
      <div
        key={startIndex + index}
        style={{
          backgroundColor: ' #fbf1ea',
          padding: '16px',
          margin: '16px 0',
          borderRadius: '8px',
        }}
      >
        <Typography variant="h5" gutterBottom>
          {assessment.question}
        </Typography>
        <RadioGroup
          value={selectedOptions[startIndex + index]}
          onChange={(event) => handleOptionChange(event, startIndex + index)}
          name={`question${startIndex + index}`}
        >
          <FormControlLabel
            value="option1"
            control={<Radio />}
            label={assessment.option1}
          />
          <FormControlLabel
            value="option2"
            control={<Radio />}
            label={assessment.option2}
          />
          <FormControlLabel
            value="option3"
            control={<Radio />}
            label={assessment.option3}
          />
          <FormControlLabel
            value="option4"
            control={<Radio />}
            label={assessment.option4}
          />
        </RadioGroup>
      </div>
    ));
  };

  const [showRecommendation, setShowRecommendation] = useState(false);

  return (
    <Container maxWidth="sm">
      {showRecommendation ? (
        <RecommendationComponent score={score} />
      ) : (
        <>
          {assessments.length > 0 ? (
            renderQuestions()
          ) : (
            <div style={{marginTop:100,marginBottom:100,marginLeft:80}}>
              <Typography variant="h6">
                Sorry, no assessments available.
              </Typography>
            </div>
          )}
          {assessments.length > 0 && !showResult && (
            <div style={{display:"flex",justifyContent:"flex-end",marginBottom:"10px"}}>
              <Button
                variant="contained"
                onClick={handleNextClick}
                disabled={!isPageAnswered}
                style={{backgroundColor:"#FF6652",color:"#FFFF"}}
              >
                Next
              </Button>
            </div>
          )}
          {showResult && (
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
              <Button
                variant="contained"
                onClick={handleFinishClick}
                style={{ backgroundColor: "#0A033C",color:"#FFFF" }}
              >
                Finish
              </Button>
            </div>
          )}
          
        </>
      )}
    </Container>
  );
};

export default AssessmentComponent;
